import { BehaviorSubject } from 'rxjs';
import { AttrIndexService } from './attr-index.service';
import * as i0 from "@angular/core";
import * as i1 from "./attr-index.service";
var InterlayerCardService = /** @class */ (function () {
    function InterlayerCardService(attrIndexService) {
        this.attrIndexService = attrIndexService;
        // subjectCards: any[] = [];
        // refCards: any[] = [];
        this.currentSbjCardBS = new BehaviorSubject({
            id: null
        });
        this.currentRefCardBS = new BehaviorSubject({
            id: null
        });
        this.sbjCardSelectionListBS = new BehaviorSubject({
            ids: []
        });
        this.refCardSelectionListBS = new BehaviorSubject({
            ids: []
        });
        this.sbjEditedListBS = new BehaviorSubject({
            ids: []
        });
        this.refEditedListBS = new BehaviorSubject({
            ids: []
        });
    }
    InterlayerCardService.prototype.getOriginalDataId = function (rec, prefix) {
        return rec[prefix + "_" + this.attrIndexService.globalIdColLower];
    };
    InterlayerCardService.prototype.findCardIdx = function (rec, cardList, prefix) {
        var _this = this;
        return cardList.findIndex(function (i) { return _this.getOriginalDataId(i, prefix) === _this.getOriginalDataId(rec, prefix); });
    };
    InterlayerCardService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function InterlayerCardService_Factory() { return new InterlayerCardService(i0.ɵɵinject(i1.AttrIndexService)); }, token: InterlayerCardService, providedIn: "root" });
    return InterlayerCardService;
}());
export { InterlayerCardService };
